import React from 'react';
import { useLanguage } from '@/i18n/LanguageContext';

const ContentBank: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">{t('app.nav.contents')}</h1>
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Content bank management will be implemented here.</p>
      </div>
    </div>
  );
};

export default ContentBank; 